"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderRulesTab = void 0;
const React = require("react");
const filter_header_1 = require("client/components/filter-header");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const switch_1 = require("client/components/material/switch");
const store_1 = require("client/modules/inventory-order/store");
const material_ui_1 = require("material-ui");
const Collapse_1 = require("material-ui/transitions/Collapse");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const throttle_debounce_1 = require("throttle-debounce");
const rule_edit_form_1 = require("./modules/rule-edit-form");
require("./order-rules.less");
const store_2 = require("client/modules/users/store");
const columns = [
    {
        label: "rule name",
        id: "name"
    },
    {
        label: "category",
        id: "category"
    },
    {
        label: "rule description",
        id: "description"
    },
    {
        label: "creator",
        id: "userId"
    },
    {
        label: "created date",
        id: "createdAt"
    }
];
let OrderRulesTab = class OrderRulesTab extends React.Component {
    constructor() {
        super(...arguments);
        this.addNewRule = false;
        this.manageRulesMode = false;
        this.showChildren = new Map();
        this.ruleSiteId = 0;
        this.filterText = "";
        this.order = "DESC";
        this.orderBy = "id";
        // @observable
        // public rulesList: IPurchaseRule[] = inventoryOrderStore.rulesList;
        this.loadPurchaseRules = throttle_debounce_1.debounce(200, async () => {
            await store_1.inventoryOrderStore.loadPurchaseRules({
                count: 100,
                order: this.order,
                search: this.filterText,
                sort: this.orderBy,
                start: 0,
                siteId: this.ruleSiteId
            });
        });
        this.handleRuleAddCancel = () => {
            this.addNewRule = false;
        };
        this.renderRuleAdd = () => (React.createElement(rule_edit_form_1.RuleEditForm, { loadPurchaseRules: this.loadPurchaseRules, onCancel: this.handleRuleAddCancel }));
        this.updateChildrenShow = (index) => () => {
            this.showChildren.set(index, !this.showChildren.get(index));
            this.showChildren.forEach((v, k) => {
                if (Number(k) !== index) {
                    this.showChildren.set(k, false);
                }
            });
        };
        this.renderRulesList = (rule, index) => (React.createElement(React.Fragment, { key: index },
            React.createElement(list_item_1.MaterialListItem, { className: "rule-row", onClick: this.updateChildrenShow(index) },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: rule.name }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: rule.category }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: rule.description }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: rule.createdAt })),
            React.createElement(Collapse_1.default, { in: this.showChildren.get(index) },
                React.createElement(rule_edit_form_1.RuleEditForm, { loadPurchaseRules: this.loadPurchaseRules, rule: rule }))));
        this.onRequestSort = (property) => {
            // console.log("property is ", property);
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadPurchaseRules();
        };
        this.onCallback = (value) => {
            this.filterText = value;
            this.loadPurchaseRules();
        };
        this.renderRuleOverview = () => {
            const rulesList = store_1.inventoryOrderStore.rulesList;
            return (React.createElement(React.Fragment, null,
                store_2.usersStore.permissions.UpdateOrderRules && (React.createElement("div", { className: "order-rules__button" },
                    React.createElement(switch_1.MaterialSwitch, { label: "Manage Rules", value: "manageRulesMode", onChange: () => (this.manageRulesMode = !this.manageRulesMode), checked: this.manageRulesMode }),
                    this.manageRulesMode && (React.createElement(button_1.MaterialButton, { variant: "flat", onClick: () => (this.addNewRule = true) }, "Add rule")))),
                React.createElement(filter_header_1.FilterHeader, { label: "Search", title: "Purchase Order Rule", callBack: this.onCallback, filterText: this.filterText }),
                React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: "ASC", orderBy: "", rows: rulesList, renderRow: this.renderRulesList })));
        };
    }
    async componentDidMount() {
        await this.loadPurchaseRules();
        const rulesList = store_1.inventoryOrderStore.rulesList;
        rulesList.forEach((rule, index) => {
            this.showChildren.set(index, false);
        });
    }
    render() {
        return (React.createElement("div", { className: "inventory-order__order-rules" },
            React.createElement(material_ui_1.Typography, { variant: "display1" }, "Order rules"),
            this.addNewRule ? this.renderRuleAdd() : this.renderRuleOverview()));
    }
};
__decorate([
    mobx_1.observable
], OrderRulesTab.prototype, "addNewRule", void 0);
__decorate([
    mobx_1.observable
], OrderRulesTab.prototype, "manageRulesMode", void 0);
__decorate([
    mobx_1.observable
], OrderRulesTab.prototype, "showChildren", void 0);
__decorate([
    mobx_1.observable
], OrderRulesTab.prototype, "ruleSiteId", void 0);
__decorate([
    mobx_1.observable
], OrderRulesTab.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], OrderRulesTab.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], OrderRulesTab.prototype, "orderBy", void 0);
OrderRulesTab = __decorate([
    mobx_react_1.observer
], OrderRulesTab);
exports.OrderRulesTab = OrderRulesTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-rules/order-rules.tsx
// module id = 3590
// module chunks = 0